module.exports = __webpack_public_path__ + "img/platform.ffefbc72.svg";